import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DataSource} from '@angular/cdk/collections';
import {ResourceDescriptor, VersionedResourceAdapter} from 'hateoas-navigator';
import {CollectionAdapter} from 'hateoas-navigator';
import {ResourceAdapter} from 'hateoas-navigator';
import {of} from 'rxjs/index';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-resource-list',
  template: `<div>
  <h1 class="mat-display-1">{{collection.getDescriptor().getTitle()}}</h1>
</div>
<mat-toolbar color="accent" class="mat-elevation-z4">
  <a mat-button [routerLink]="getNewLink()" *ngIf="isAddEnabled()">
    <mat-icon class="md-24" aria-label="Add new item">add</mat-icon>
    <span>Add</span>
  </a>
</mat-toolbar>
<mat-table #table [dataSource]="dataSource" class="mat-elevation-z4">
  <ng-container *ngFor="let propertyName of collection.getPropertyNames()" [matColumnDef]="propertyName">
    <mat-header-cell *matHeaderCellDef>{{getPropertyTitle(propertyName)}}</mat-header-cell>
    <mat-cell *matCellDef="let row">{{getDisplayValue(row, propertyName)}}</mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="collection.getPropertyNames()"></mat-header-row>
  <mat-row *matRowDef="let row; columns: collection.getPropertyNames();" (click)="onClick(row)" class="app-pointer"></mat-row>
</mat-table>
`,
  styles: [``]
})
export class ResourceListComponent implements OnInit {

  collection: CollectionAdapter;
  propertyNames: Array<string>;

  dataSource: DataSource<ResourceAdapter>;

  constructor(private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.data
      .pipe(map((data: ResourceListRouteData) => data.collectionAdapter))
      .subscribe(collection => {
        this.initTableMetadata(collection);
        this.initDataSource(collection);
      });
  }

  /**
   * @deprecated
   */
  getPropertyTitle(property: string) {
    return this.collection.getDescriptor().getChildDescriptor(property).getTitle();
  }

  /**
   * @deprecated
   */
  getNewLink(): string {
    return 'new';
  }

  onClick(item: VersionedResourceAdapter) {
    this.router.navigateByUrl(item.getSelfLink().getRelativeUri());
  }

  /**
   * @deprecated
   */
  getDisplayValue(item: VersionedResourceAdapter, propertyName: string) {
    return item.getPropertyAs(propertyName, d => d.getDisplayValue());
  }

  isAddEnabled() {
    const descriptor: ResourceDescriptor = this.collection.getDescriptor();
    return descriptor.getActions().isCreateEnabled();
  }

  private initTableMetadata(collection: CollectionAdapter) {
    this.collection = collection;
    this.propertyNames = this.collection.getPropertyNames();
  }

  private initDataSource(collection: CollectionAdapter) {
    this.dataSource = {
      connect: () => of(collection.getItems()),
      disconnect: () => {
      }
    };
  }
}

interface ResourceListRouteData {
  collectionAdapter: CollectionAdapter;
}
